import React, { useEffect } from "react";
import { BrowserRouter, Navigate, Outlet, Route, Routes, useParams } from "react-router-dom";
import "./App.css";
import { I18nProvider, LANGS, DEFAULT_LANG, useI18n } from "./i18n";
import { UiProvider } from "./lib/ui";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import ContactModal from "./components/ContactModal";
import ScrollToTop from "./components/ScrollToTop";
import LegalPage from "./components/LegalPage";
import Home from "./pages/Home";
import ThankYou from "./pages/ThankYou";

function DocumentMeta() {
  const { t, lang } = useI18n();
  useEffect(() => {
    document.documentElement.lang = lang === "ar" ? "es-AR" : "en";
    document.title = t("meta.title");
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", t("meta.description"));
  }, [t, lang]);
  return null;
}

function LangLayout() {
  const { lang } = useParams();
  if (!LANGS.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  }
  return (
    <I18nProvider lang={lang}>
      <DocumentMeta />
      <ScrollToTop />
      <div className="site-shell">
        <Header />
        <Outlet />
        <Footer />
      </div>
      <ContactModal />
      <CookieBanner />
    </I18nProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <UiProvider>
        <Routes>
          <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
          <Route path="/thank_you" element={<ThankYou />} />
          <Route path="/:lang" element={<LangLayout />}>
            <Route index element={<Home />} />
            <Route path="privacy" element={<LegalPage ns="privacy" />} />
            <Route path="cookies" element={<LegalPage ns="cookies" />} />
            <Route path="terms" element={<LegalPage ns="terms" />} />
            <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
          </Route>
          <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        </Routes>
      </UiProvider>
    </BrowserRouter>
  );
}
